<template>
    <div class="share-popup">

        <div class="posterHtml">
            <div class="posterHtml-title">
                <p>{{ user.name }}</p>
                <p>邀您一起参加，快来报名吧！</p>
                <p>Inviting you to join us, come and register now!</p>
            </div>
            <img class="posterHtml-img" :src="mainImg" alt />

            <div class="posterConent">
                <p class="title">{{ defaultInfo.config.name }}</p>
                <p>{{ defaultInfo.config.startTime }}</p>
                <p>{{ defaultInfo.config.address }}</p>
            </div>

            <div class="posterHtml-wrap">

                <div class="poster-qrcode">
                    <vue-qr :text="copyContent" :size="200"></vue-qr>
                    <p>长按识别二维码报名参加</p>
                    <p>Long press the identification QR code to register and participate</p>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import vueQr from 'vue-qr';
import { mapGetters } from 'vuex';

export default {
    props: {
        user: {
            type: Object,
            default: () => {
                return {};
            },
        },
    },
    data() {
        return {
            base64Img: '',
            showShare: false,
            copyContent: '',
        };
    },
    components: {
        vueQr,
    },
    computed: {
        ...mapGetters(['defaultInfo']),
        mainImg() {
            return this.defaultInfo.config.shareImg;
        },
    },
    watch: {
        user(newValue, oldValue) {
            const { acid } = this.getUrlCode();
            var path = this.defaultInfo.config.homeUrl || 'login';
            let url = process.env.VUE_APP_H5_API + '/?acid=' + acid + '#/' + path;
            this.copyContent = `${url}?source=${this.user.id}`;
        },
    },
    methods: {
        open() {
            this.showShare = true;
        },

        getUrlCode() {
            // 截取url中的code方法
            var url = location.search;
            var theRequest = new Object();
            if (url.indexOf('?') != -1) {
                var str = url.substr(1);
                var strs = str.split('&');
                for (var i = 0; i < strs.length; i++) {
                    theRequest[strs[i].split('=')[0]] = strs[i].split('=')[1];
                }
            }
            return theRequest;
        },

        // getConfigImg() {
        //     httpRequest.get(`/api/config/getConfigImg`).then(res => {
        //         if (res.data.code == 200) {
        //             this.base64Img = 'data:image/png;base64,' + res.data.data;
        //         }
        //     });
        // },
    },
    created() {
        // this.getConfigImg();
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/mixin.scss';

.posterHtml {
    box-sizing: border-box;
    color: #000;
    padding: 20px;
    border-radius: 2px;
    background: #fff;

    img {
        width: 100%;
    }

    .posterConent {
        padding: 10px;

        .title {
            font-weight: bold;
            font-size: 16px;
        }

        p {
            margin-bottom: 5px;
            font-size: 16px;
        }
    }

    .posterHtml-title {
        margin-bottom: 10px;

        p {
            padding: 5px;
        }
    }

    .posterHtml-img {
        border-radius: 10px;
    }

    .posterHtml-wrap {
        width: 100%;

        background: #fff;
        display: flex;

        justify-content: center;

        .poster-qrcode {
            padding: 0 10px;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            img {
                width: 100px;
                height: 100px;
            }
            p {
                color: #999;
                font-size: 14px;
            }
        }
    }
}

.shareImg {
    height: 100%;
    width: 100%;
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    z-index: 99;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    background: rgba(0, 0, 0, 0.5);

    .qr-code {
        width: 80%;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;

        .poster-img {
            width: 100%;
        }
        p {
            margin-top: 10px;
            color: #fff;
            text-align: center;
        }

        .close {
            margin-top: 8px;
            width: 50px;
            height: 50px;
        }
    }
}
</style>